import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { DisplayImage } from '../../widgets/components/General/DisplayImage'
import { Dropdown } from 'react-bootstrap'
import { DeleteConfirmationModal } from '../../widgets/components/DeleteConfirmationModal'
import { AddBoardAdvisorModal } from './AddBoardAdvisorModal'
import { Spinner } from '../../widgets/components/General/Spinner'
import { deleteBoardAdvisors } from '../core/_requests'
import { toast } from 'react-toastify'
import { useDateFormat } from '../../../hooks/useDateFormat'
import { DateTime } from 'luxon'
import NoDataPage from '../../widgets/components/NoDataPage'
import { membersType } from '../core/_constants'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../hooks/gtmHelpers'
import { useAuth } from '../../auth'

export const BoardMembers = ({
  getAllCompanyBoardAdvisors,
  boardAdvisorsApiLoading,
  companyBoardAdvisorsData,
  companyPageData,
  publicStatus,
  publicCompanyPageLoading,
}: {
  getAllCompanyBoardAdvisors: any
  boardAdvisorsApiLoading: boolean
  companyBoardAdvisorsData: any
  companyPageData: any
  publicStatus: boolean | undefined
  publicCompanyPageLoading: boolean
}) => {
  const { formatMessage } = useIntl()
  const [IsHovering, setIsHovering] = useState(false)
  const [memberiIndex, setMemberIndex] = useState<number>(0)
  const [companyBoardAdvisorsId, setCompanyBoardAdvisorsId] = useState<number>()
  const [showBoardAdvisorsModal, setShowBoardAdvisorsModal] = useState(false)
  const [updateModalStatus, setUpdateModalStatus] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [showDeleteModal, setDeleteShowModal] = useState(false)
  const { getDateValue } = useDateFormat()
  const [memberType, setMemberType] = useState('')
  const [advisor, setAdvisor] = useState<any>()
  const [imgName, setImgName] = useState<string>()
  const { currentUser, companyId } = useAuth()

  const handleBoardAdvisorsDelete = async (companyBoardAdvisorsId: number) => {
    try {
      setDeleteLoading(true)
      if (companyBoardAdvisorsId) {
        const {
          data: { success, errors },
        } = await deleteBoardAdvisors(companyBoardAdvisorsId)
        if (success) {
          setDeleteLoading(false)
          setDeleteShowModal(false)
          getAllCompanyBoardAdvisors()
          toast.success(formatMessage({ id: 'Company Board Member deleted successfully' }))
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.DeleteBoardAdvisorsSuccessful,
              action: 'normal',
              metadata: {
                company_board_advisors_id: companyBoardAdvisorsId,
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
              },
            },
          })
        } else {
          setDeleteLoading(false)
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.DeleteBoardAdvisorsFailed,
              action: 'normal',
              metadata: {
                company_board_advisors_id: companyBoardAdvisorsId,
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
              },
            },
          })
        }
      }
    } catch (err) {
      setDeleteLoading(false)
      console.log(err)
    }
  }

  useEffect(() => {
    const advisors = companyBoardAdvisorsData?.filter((member: any) => member.type === 'ADVISOR')
    setAdvisor(advisors)
  }, [companyBoardAdvisorsData])
  return (
    <>
      {(publicStatus === false ? boardAdvisorsApiLoading : publicCompanyPageLoading) ? (
        <Spinner />
      ) : null}
      <div className='card p-7 mt-6 company-page-dark'>
        <div className='d-flex flex-md-row flex-column justify-content-between align-items-start col-12'>
          <div className='d-flex col-md-7 col-12 justify-content-between gap-md-10 gap-4 flex-md-row flex-column'>
            <div className='col-md-6  bg-clrF3 p-2 px-5 col-12 main-section-dark-bg rounded'>
              <p className='my-2 font-size-13 font-weight-500 text-clr38 main-section-dark-color'>
                {formatMessage({ id: 'Board Members' })}
              </p>
              <p className='text-clr58 font-size-16 font-weight-600 dark_text_color'>
                {companyBoardAdvisorsData?.length - advisor?.length}
              </p>
            </div>
            <div className='col-md-6  bg-clrF3 p-2 px-5 col-12 main-section-dark-bg rounded'>
              <p className='my-2 font-size-13 font-weight-500 text-clr38 main-section-dark-color'>
                {formatMessage({ id: 'Advisors' })}
              </p>
              <p className='text-clr58 font-size-16 font-weight-600 dark_text_color'>
                {advisor?.length}
              </p>
            </div>
          </div>
          {publicStatus === false && (
            <div className='mt-md-0 mt-4 d-flex flex-md-row flex-column gap-3 w-md-auto w-100'>
              {/* <BasicButton
                buttonText={formatMessage({ id: 'Add Board Members' })}
                height='36px'
                width='174px'
                border='none'
                color='#4776E6'
                textColor='#FFFFFF'
                padding='8px 20px'
                onClick={() => {
                  setUpdateModalStatus(false)
                  setShowBoardAdvisorsModal(true)
                  setMemberType('member')
                }}
              /> */}
              <button
                className='btn bg-primary custom-button-property text-white py-3'
                onClick={() => {
                  setUpdateModalStatus(false)
                  setShowBoardAdvisorsModal(true)
                  setMemberType('member')
                }}
              >
                {formatMessage({ id: 'Add Board Members' })}
              </button>
              {/* <BasicButton
                buttonText={formatMessage({ id: 'Add Advisors' })}
                height='36px'
                width='174px'
                border='none'
                color='#4776E6'
                textColor='#FFFFFF'
                padding='8px 20px'
                customClass='dark_bg_white'
                onClick={() => {
                  setUpdateModalStatus(false)
                  setShowBoardAdvisorsModal(true)
                  setMemberType(membersType.ADVISOR)
                }} 
              /> */}
              <button
                className='btn bg-light custom-button-property text-muted py-3'
                onClick={() => {
                  setUpdateModalStatus(false)
                  setShowBoardAdvisorsModal(true)
                  setMemberType(membersType.ADVISOR)
                }}
              >
                {formatMessage({ id: 'Add Advisors' })}
              </button>
            </div>
          )}
        </div>
        {!boardAdvisorsApiLoading && companyBoardAdvisorsData.length === 0 ? (
          <NoDataPage width={`0`} bgTransparent />
        ) : (
          <div>
            <div className='mt-5 text-wrap'>
              {companyBoardAdvisorsData &&
                companyBoardAdvisorsData.length > 1 &&
                companyPageData &&
                `${companyPageData?.name} ${formatMessage({ id: 'is funded by' })} ${companyBoardAdvisorsData?.length
                } ${formatMessage({ id: 'board members.' })} ${companyBoardAdvisorsData[companyBoardAdvisorsData?.length - 2]?.name
                } ${formatMessage({ id: 'and' })} ${companyBoardAdvisorsData[companyBoardAdvisorsData?.length - 1]?.name
                } ${formatMessage({ id: 'are the most recent members.' })}`}
            </div>
            <div className='mt-6 board-member'>
              {companyBoardAdvisorsData &&
                companyBoardAdvisorsData?.map((member: any, index: any) => (
                  <div
                    key={member.companyBoardAdvisorsId}
                    className='d-flex gap-3 p-6'
                    onMouseEnter={() => {
                      setIsHovering(true)
                      setMemberIndex(index)
                    }}
                    onMouseLeave={() => setIsHovering(false)}
                  >
                    <div>
                      <DisplayImage
                        imgName={member?.file?.name}
                        width='76px'
                        height='76px'
                        alt={formatMessage({ id: 'profile' })}
                        fit='contain'
                        className='rounded-3'
                      />
                    </div>
                    <div>
                      <p className='text-clr38 font-size-16 font-weight-600 my-1 dark_text_color'>
                        {member?.name}
                      </p>
                      <p className='text-clr58 font-size-12 font-weight-500 my-0'>
                        {member?.designation}
                      </p>
                      <p className='text-clr58 font-size-12 font-weight-500 my-1'>
                        {member?.joining_month
                          ? getDateValue(new Date(member?.joining_month).toISOString()?.toString())
                            ? getDateValue(
                              new Date(member?.joining_month).toISOString()?.toString()
                            )
                            : DateTime.fromISO(
                              new Date(member?.joining_month).toISOString()?.toString()
                            ).toLocaleString(DateTime.DATE_MED)
                          : '-'}
                      </p>
                    </div>
                    {IsHovering && memberiIndex === index && publicStatus === false && (
                      <div>
                        <Dropdown>
                          <div id='remove-investor'>
                            <Dropdown.Toggle className='bi bi-three-dots-vertical me-1 p-1 px-3 py-2 bg-light text-dark dark_bg_white'></Dropdown.Toggle>
                          </div>
                          <Dropdown.Menu className='m-2'>
                            <Dropdown.Item className='text-primary'>
                              <p
                                className='mb-0'
                                onClick={() => {
                                  setCompanyBoardAdvisorsId(member?.companyBoardAdvisorsId)
                                  setUpdateModalStatus(true)
                                  setShowBoardAdvisorsModal(true)
                                  if (member.type === 'ADVISOR') {
                                    setMemberType(membersType.ADVISOR)
                                  } else {
                                    setMemberType('member')
                                  }
                                  if (member.file?.fileId !== null) {
                                    setImgName(member.file?.name)
                                  } else {
                                    setImgName(undefined)
                                  }
                                }}
                              >
                                {formatMessage({ id: 'Edit' })}
                              </p>
                            </Dropdown.Item>
                            <Dropdown.Item className='text-danger'>
                              <p
                                className='mb-0'
                                onClick={() => {
                                  setCompanyBoardAdvisorsId(member?.companyBoardAdvisorsId)
                                  setDeleteShowModal(true)
                                  if (member.type === 'ADVISOR') {
                                    setMemberType(membersType.ADVISOR)
                                  } else {
                                    setMemberType('member')
                                  }
                                }}
                              >
                                {formatMessage({ id: 'Delete' })}
                              </p>
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    )}
                  </div>
                ))}
            </div>
          </div>
        )}
      </div >
      <AddBoardAdvisorModal
        setShowBoardAdvisorsModal={setShowBoardAdvisorsModal}
        showBoardAdvisorsModal={showBoardAdvisorsModal}
        companyBoardAdvisorsId={companyBoardAdvisorsId}
        updateModalStatus={updateModalStatus}
        getAllCompanyBoardAdvisors={getAllCompanyBoardAdvisors}
        memberType={memberType}
        setImgName={setImgName}
        imgName={imgName}
      />
      <DeleteConfirmationModal
        showDeleteModal={showDeleteModal}
        setDeleteShowModal={setDeleteShowModal}
        headingMessage={formatMessage({
          id:
            memberType === membersType.ADVISOR
              ? 'Delete Company Advisor'
              : 'Delete Company Board Member',
        })}
        description={formatMessage({
          id:
            memberType === membersType.ADVISOR
              ? 'Are you sure you want to Delete this Company Advisor?'
              : 'Are you sure you want to Delete this Company Board Member?',
        })}
        handleDelete={handleBoardAdvisorsDelete}
        deleteLoading={deleteLoading}
        id={companyBoardAdvisorsId}
      />
    </>
  )
}
